import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@app/services/authorization.service';
import { AuthenticationService } from '@app/services/authentication.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css'],
  standalone: false
})
export class ForbiddenComponent implements OnInit {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.authenticationService.ensureSession().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        const accessibleRoute = this.authorizationService.getFirstAccessibleUserRoute();
        if (accessibleRoute && accessibleRoute !== '/forbidden') {
          this.router.navigate([accessibleRoute]);
        }
      }
    });
  }

  goToCustomers() {
    const route = this.authorizationService.getFirstAccessibleUserRoute();
    if (route && route !== '/forbidden') {
      this.router.navigate([route]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}